import apiBase from "../../api/axios";

// ============================================================
// ÁREAS DE DESARROLLO PLANTEL
// ============================================================

export const getAreasDesarrolloPlantelService = async ({
  plantelId,
  page = 1,
  search = "",
} = {}) => {
  let url = `v1/talentos-plantel/areas-desarrollo/?page=${page}&plantel=${plantelId}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const getAreaDesarrolloPlantelByIdService = async (id) => {
  const response = await apiBase.get(`v1/talentos-plantel/areas-desarrollo/${id}/`);
  return response.data;
};

export const updateAreaDesarrolloPlantelService = async (id, payload) => {
  const response = await apiBase.put(`v1/talentos-plantel/areas-desarrollo/${id}/`, payload);
  return response.data;
};

export const toggleAreaDesarrolloPlantelActiveService = async (id) => {
  const response = await apiBase.post(`v1/talentos-plantel/areas-desarrollo/${id}/toggle_active/`);
  return response.data;
};

export const getAreasSelectoresPlantelService = async (plantelId, search = "") => {
  let url = `v1/talentos-plantel/selectores/areas-desarrollo/?plantel=${plantelId}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  const response = await apiBase.get(url);
  return response.data;
};

// ============================================================
// ACCIONES DE DESARROLLO PLANTEL
// ============================================================

export const getAccionesDesarrolloPlantelService = async ({
  plantelId,
  page = 1,
  search = "",
  area = "",
  talento = "",
} = {}) => {
  let url = `v1/talentos-plantel/acciones-desarrollo/?page=${page}`;
  if (plantelId) url += `&plantel=${plantelId}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (area) url += `&area=${area}`;
  if (talento) url += `&talento=${talento}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const getAccionDesarrolloPlantelByIdService = async (id) => {
  const response = await apiBase.get(`v1/talentos-plantel/acciones-desarrollo/${id}/`);
  return response.data;
};

export const createAccionDesarrolloPlantelService = async (payload) => {
  const response = await apiBase.post("v1/talentos-plantel/acciones-desarrollo/", payload);
  return response.data;
};

export const createMultiplesAccionesPlantelService = async (payload) => {
  const response = await apiBase.post("v1/talentos-plantel/acciones-desarrollo/crear-multiples/", payload);
  return response.data;
};

export const updateAccionDesarrolloPlantelService = async (id, payload) => {
  const response = await apiBase.put(`v1/talentos-plantel/acciones-desarrollo/${id}/`, payload);
  return response.data;
};

export const toggleAccionDesarrolloPlantelActiveService = async (id) => {
  const response = await apiBase.post(`v1/talentos-plantel/acciones-desarrollo/${id}/toggle_active/`);
  return response.data;
};
